module.exports = __webpack_public_path__ + "static/media/ArrowLeft.19de51a2.svg";